<template>
  <div id="contents">
    <Navbar
      :link="$paths.contents.categories.list"
      linkName="Conteúdos"
      current="Todos"
    />
    <Sidebar />
    <Container col="col-12">
      <Header
        title="Conteúdos"
        subtitle="Lista de todos os conteúdos"
        icon="fa-regular fa-file-lines"
      >
      </Header>

      <div class="card">
        <SearchBar v-if="totalItemsRegistered > 0" @onSearch="search" />
        <LoadingContainer v-if="loadingItems" />
        <div v-else>
          <EmptyState
            v-if="!items.length"
            :totalItemsRegistered="totalItemsRegistered"
            icon="fa-regular fa-file-lines"
          >
          </EmptyState>
          <div v-else class="table-responsive">
            <table
              class="table table-sm table-nowrap card-table table-hover cursor-pointer"
            >
              <TableHead :columns="columns" v-on:sort="sort" />
              <tbody class="list">
                <router-link
                  tag="tr"
                  v-for="(item, index) in items"
                  v-bind:key="'tr-' + index"
                  :to="`${$paths.contents.detail}/${item.id}`"
                >
                  <td>{{ item.name }}</td>
                  <td class="text-end">
                    <time>{{
                      $moment(item.created_at).format("DD/MM/YYYY")
                    }}</time>
                  </td>
                  <td class="text-end">
                    <button
                      v-if="item.detail_url_copied"
                      class="btn btn-sm btn-outline-success me-3"
                    >
                      <span class="fas fa-copy"></span> Copiado!
                    </button>
                    <HyperlinkDropDown
                      v-else
                      @onSelected="(link) => copyURL(item, index, link)"
                    />
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-if="!loadingItems">
        <div class="col-12 text-end">
          <span class="text-muted"
            >mostrando <b>{{ countItemsShowing }}</b> de
            <b>{{ countItemsTotal }}</b> resultado(s)</span
          >
        </div>
      </div>
      <div
        class="row justify-content-center"
        v-if="!loadingItems && moreItemsToLoad"
      >
        <div class="col-2">
          <FormButton
            label="Carregar mais"
            :loading="loadingMoreItems"
            @onClick="loadMore"
          />
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import AllContentsController from "./AllContentsController.js";
export default AllContentsController;
</script>
